<template>
  <div id="app" class="page-wrapper d-flex flex-column">
    <nav class="navbar navbar-expand-md sticky-top shadow-sm">
      <a class="navbar-brand px-3" href="/">
        <svg class="icon mr-1" aria-hidden="true">
          <use xlink:href="#icon-flower4f" />
        </svg>
        <span>Rmdyh</span>
      </a>
      <button
        class="dashboard navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#collapsibleNavbar"
      >
        <svg class="icon" aria-hidden="true">
          <use xlink:href="#icon-adashboardbuttonterminal" />
        </svg>
      </button>
      <div id="collapsibleNavbar" class="collapse navbar-collapse">
        <ul class="navbar-nav">
          <li class="nav-item px-2" :class="{active:$route.path=='/'}">
            <a class="nav-link" href="/">Home</a>
          </li>
          <li class="nav-item px-2">
            <a class="nav-link" href="/archive">Archive</a>
          </li>
          <li class="nav-item px-2">
            <a class="nav-link" href="/tags">Tags</a>
          </li>
          <li class="nav-item px-2">
            <a class="nav-link" href="#">Unlock</a>
          </li>
          <li class="nav-item px-2">
            <a class="nav-link" href="/about">About</a>
          </li>
        </ul>
      </div>
    </nav>
    <div class="main-panel flex-grow-1">
      <keep-alive>
        <router-view>
          <loading />
        </router-view>
      </keep-alive>
    </div>
    <div class="footer">
      <div class="container">
        <div class="row">
          <div class="col-xl-5 col-lg d-flex flex-column justify-content-between footer-left">
            <div>
              <h4>Get in Touch</h4>
              <p>Any problems with the website you want me known? Or how about just a friendly chat? Give me an email and we can grab a lovely brew:)</p>
            </div>
            <div>
              <p class="mb-0">
                <span class="d-block font-weight-bold">Email:</span>
                <a href="mailto:rmdyh@hotmail.com">rmdyh@hotmail.com</a>
              </p>
            </div>
          </div>
          <div class="col-xl-7 col-lg d-flex flex-column justify-content-between footer-right">
            <div>
              <h4>Special Thanks</h4>
              <p>
                Developed by
                <a href="https://webpack.js.org/">Webpack</a> |
                <a href="https://vuejs.org/">Vue</a> |
                <a href="https://v4.bootcss.com/">Bootstrap4</a>.
                <br />Thanks for
                <a href="https://codepen.io/brady_wright/pen/NNOvrW">the timeline CSS</a>
                made by Brady Wright, the elegant icons provided by
                <a
                  href="https://www.iconfont.cn/"
                >Iconfont</a>,
                the markdown CSS theme developed by
                <a
                  href="https://sspai.com/post/43873"
                >Sspai</a>
                and the artworks I used in my slideshow at the 'Home' page.
              </p>
            </div>
            <div>
              <hr />
              <p class="footer-tail mb-0">Tech-nerds save the world.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import '@/assets/js/flower4f.js'
import '@/assets/js/dashboard.js'

export default {
  name: 'App'
}
</script>

<style lang="scss">
@import "@/assets/scss/global.scss";

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: justify;
  color: theme-color("font-dark");
  background-color: gray("100");
}

nav {
  color: theme-color("primary");
  background-color: theme-color("navbar");
  .nav-link {
    @extend a;
    text-align: center;
  }
  .navbar-brand {
    transition: color 0.2s ease;
    &:hover {
      color: theme-color-level("primary", -5);
    }
    .icon {
      display: inline-block;
      vertical-align: text-bottom;
      height: 30px;
      width: 30px;
    }
  }
  .dashboard {
    background: none;
    border: none;
    padding: 0.2rem 0.4rem;
    &:focus {
      outline: none;
    }
    .icon {
      color: theme-color("primary");
      height: 20px;
      width: 20px;
    }
  }
}

.footer {
  background-color: theme-color("footer");
  padding: 3rem 0 1rem;
  hr {
    border-color: theme-color-level("footer", 1);
    margin: 0 0 0.2rem;
  }
  .footer-tail {
    color: theme-color-level("footer", 1);
  }
  .footer-right {
    padding-top: 2rem;
  }
}

.page-wrapper {
  min-height: 100vh;
}

@media (min-width: 992px) {
  .footer {
    padding-bottom: 3rem;
    .footer-left {
      padding-right: 6%;
    }
    .footer-right {
      padding-left: 6%;
      padding-top: 0;
    }
  }
}
</style>
